import React from 'react';
import { useFormContext } from 'react-hook-form';

import { FormContainerTextArea } from '@/components/common/Form/Container/TextArea';
import { TitleSectionTitle } from '@/components/common/Title/SectionTitle';
import { ToggleLabelButton } from '@/components/common/Form/ToggleLabelButton';
import { PLACEHOLDER } from '@/definition/PLACEHOLDER';
import { TSectionProps } from '@/pages/Resume/Confirmation/Edit';

export const ResumeFormSectionInterestThings = ({
  id,
  original,
}: TSectionProps): React.ReactElement => {
  const methods = useFormContext();
  const interest_things_check = methods.watch('interest_things_check');

  return (
    <div id={id}>
      <TitleSectionTitle>
        <div className="flex items-center">
          <span className="mr-4">趣味・特技</span>
        </div>
      </TitleSectionTitle>
      <div>
        <ToggleLabelButton name="interest_things_check" className="mb-16" />
        {interest_things_check ? (
          <FormContainerTextArea
            name="interest_things"
            rows={5}
            maxLength={150}
            className="mkt_mask_items"
            placeholder={PLACEHOLDER.interest_things}
            noLineBreaks={true}
          />
        ) : (
          <div className="mbx-formContainer mbx-formContainer--textarea pointer-events-none opacity-40">
            {original ? (
              original
            ) : (
              <span className="opacity-50">{PLACEHOLDER.interest_things}</span>
            )}
          </div>
        )}
      </div>
    </div>
  );
};
